import getOr from 'lodash/fp/getOr';

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SLACK_SUPPORT_URL, TEAM_EMAIL } from '~/features/base/constants/supportLinks';

export const RenderingError = ({ error }) => {
    const message = getOr('', 'message', error);
    const stack = getOr('', 'stack', error);
    const isProduction = import.meta.env.PROD;

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <div className='padding-20'>
            <h1 className='text-size-h2 text-color-darker margin-bottom-10'>
                <FormattedMessage id='intl-msg:error.somethingWentWrong'/>
            </h1>
            <div className='margin-bottom-20'>
                <button type='button' className='btn btn-primary' onClick={handleReload}>
                    <span className='rioglyph rioglyph-refresh margin-right-5'></span>
                    <FormattedMessage id='intl-msg:error.reload' defaultMessage='Reload'/>
                </button>
            </div>
            <div className='margin-bottom-20'>
                <span className='text-color-gray text-size-14'>
                    <FormattedMessage
                        id='intl-msg:error.supportContact'
                        defaultMessage='If the problem persists, contact us via {slack} or email {email}'
                        values={{
                            slack: <a href={SLACK_SUPPORT_URL} target='_blank' rel='noopener noreferrer' className='text-color-primary'>Slack support channel</a>,
                            email: <a href={`mailto:${TEAM_EMAIL}`} className='text-color-primary'>{TEAM_EMAIL}</a>,
                        }}
                    />
                </span>
            </div>
            {!isProduction && (
                <div className='margin-top-20'>
                    <div className='margin-bottom-10'>
                        <span className='text-color-danger text-size-18'>
                            {message}
                        </span>
                    </div>
                    <pre className='bg-lightest padding-10 rounded text-size-12 overflow-auto'>
                        {stack}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default RenderingError;

RenderingError.propTypes = {
    // props
    error: PropTypes.object,
};
